import { render } from "./screen-watermark-edit.vue?vue&type=template&id=755c8971&scoped=true&ts=true"
import script from "./screen-watermark-edit.vue?vue&type=script&lang=ts"
export * from "./screen-watermark-edit.vue?vue&type=script&lang=ts"

import "./screen-watermark-edit.vue?vue&type=style&index=0&id=755c8971&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755c8971"]])

export default __exports__